import { makeStyles } from '@material-ui/core/styles'
import ImageBannerDesktop from 'assets/illustrations/aerce/landing-banner-d.jpg'

const useStyles = makeStyles(theme => ({
  landing: {
    overflowX: 'hidden',
  },
  banner: {
    backgroundColor: theme.palette.common.white,
    marginTop: theme.spacing(-8),
    marginBottom: theme.spacing(3),
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      backgroundImage: `url(${ImageBannerDesktop})`,
      backgroundSize: 'cover',
      backgroundPosition: 'top',
      backgroundRepeat: 'no-repeat',
      marginBottom: theme.spacing(4),
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(11),
    },
  },
  bannerSecondBlock: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  bannerTitle: {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(2),
    fontSize: 36,
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(5),
    },
  },
  bannerSubtitle: {
    color: theme.palette.grey[200],
    marginBottom: theme.spacing(4),
  },
  bannerButton: {
    marginBottom: theme.spacing(2),
  },
  feature: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
      marginLeft: theme.spacing(-1),
    },
  },
  featureHeading: {
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(1),
    fontSize: 24,
  },
  featureText: {
    color: theme.palette.grey[200],
    fontSize: 16,
  },
  featureSubtitle: {
    color: theme.palette.grey[200],
    fontSize: 16,
    marginBottom: theme.spacing(2),
  },
  featureTitle: {
    color: theme.palette.primary.dark,
    fontSize: 36,
    paddingTop: theme.spacing(1),
  },
  featureImage: {
    maxWidth: theme.spacing(13),
    marginBottom: theme.spacing(1),
  },
  featureDivider: {
    marginTop: 90,
    marginBottom: 30,
  },
  sectionBenefit: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
  },
  sectionBenefitTitle: {
    color: theme.palette.common.white,
    fontSize: 36,
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(5),
    },
  },
  sectionBenefitSubtitle: {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(4),
  },
  sectionBenefitButton: {
    color: theme.palette.primary.light,
    backgroundColor: theme.palette.primary.lighter,
    marginBottom: theme.spacing(2),
    '&:hover': {
      backgroundColor: theme.palette.primary.lighter,
    },
  },
  sectionDownload: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.dark,
  },
  sectionDownloadTitle: {
    color: theme.palette.common.white,
    fontSize: 20,
    lineHeight: 1.6,
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
      marginBottom: theme.spacing(0),
      fontSize: 24,
      lineHeight: 1.33,
    },
  },
  sectionDownloadButton: {
    color: theme.palette.primary.light,
    backgroundColor: theme.palette.primary.lighter,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(3),
    '&:hover': {
      backgroundColor: theme.palette.primary.lighter,
    },
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(2),
      textAlign: 'left',
    },
  },
}))

export default useStyles
